import { useState, useCallback, useMemo } from 'react';
import { Ajax } from './Ajax';

export const useAction = (action) => {
  const { cancel, cancelToken } = useMemo(() => {
    let newCancel;

    const newCancelToken = new Ajax.CancelToken((cancelCallback) => {
      newCancel = cancelCallback;
    });

    return { cancel: newCancel, cancelToken: newCancelToken };
  }, []);
  const [request, setRequest] = useState({
    loading: false,
  });
  const performAction = useCallback(async (params, done, fail) => {
    setRequest({ loading: true });

    const { status, data: result, hasError, isCanceled } = await action(params, cancelToken);

    let error;
    let data;

    if (hasError) {
      error = result || { isCanceled };

      if (fail) {
        fail(result);
      }
    } else {
      data = result;

      if (done) {
        done(result);
      }
    }

    setRequest({
      loading: false,
      status,
      data,
      error,
    });
  }, []);

  return [request, performAction, cancel];
};

export default useAction;
